/* Yooppee wishlist, phase 1: stored in this browser only (no account sync).
   Phase 2 (assets/wishlist-sync.js + snippets/wishlist-sync-config.liquid) syncs
   this list with the account of a LOGGED-IN customer through the HMAC-signed
   service; logged out nothing ever leaves the browser. The sync script feeds the
   server answer back in with YPWishlist.replace(list), which notifies listeners
   with type 'replace' (source 'sync'): listeners must ignore it, because no
   user-visible add/remove happened and no analytics may be published.
   Storage: localStorage 'yp_wishlist_v1' = [{handle, id, variantId, addedAt, source,
   productTitle, variantTitle, price, currency}], newest first, capped at 100.
   Metadata is optional for backward compatibility with older entries. Other
   tabs follow through the 'storage' event.
   Any <button data-wishlist-toggle data-handle data-product-id> is a heart
   (snippets/wishlist-button.liquid); hearts added later (keycap modal, AJAX
   grids, the panel) are picked up by a MutationObserver.
   Analytics: Shopify.analytics.publish('wishlist_add' | 'wishlist_remove' |
   'wishlist_add_to_cart', {product_id, handle, variant_id, source}) when the
   storefront exposes it. API: window.YPWishlist (has, add, remove, toggle,
   replace, list, count, publish, onChange, refresh, open/close from the panel). */
(function () {
  'use strict';
  if (window.YPWishlist) {
    return;
  }
  var KEY = 'yp_wishlist_v1';
  var CAP = 100;
  var memory = null; /* fallback when localStorage is blocked (private mode etc.) */
  var listeners = [];

  function readRaw() {
    try {
      return window.localStorage.getItem(KEY);
    } catch (e) {
      return memory;
    }
  }
  function writeRaw(value) {
    memory = value;
    try {
      window.localStorage.setItem(KEY, value);
    } catch (e) {
      /* keep the in-memory copy */
    }
  }
  function load() {
    var raw = readRaw();
    var list = [];
    if (raw) {
      try {
        list = JSON.parse(raw);
      } catch (e) {
        list = [];
      }
    }
    if (!Array.isArray(list)) {
      list = [];
    }
    return list.filter(function (it) {
      return it && typeof it.handle === 'string' && it.handle !== '';
    }).slice(0, CAP);
  }
  var items = load();

  function save() {
    writeRaw(JSON.stringify(items));
  }
  function indexOf(handle) {
    for (var i = 0; i < items.length; i++) {
      if (items[i].handle === handle) {
        return i;
      }
    }
    return -1;
  }
  function toId(value) {
    var n = parseInt(value, 10);
    return isNaN(n) ? null : n;
  }
  function textOrNull(value) {
    return typeof value === 'string' && value !== '' ? value : null;
  }
  function variantTitle(value) {
    if (typeof value !== 'string') {
      return null;
    }
    var title = value.trim();
    return !title || title.toLowerCase() === 'default title' ? null : title;
  }
  function validPrice(value) {
    var price = typeof value === 'number' ? String(value) : value;
    return typeof price === 'string' && /^\d{1,8}(\.\d{1,2})?$/.test(price) ? price : null;
  }
  function priceFromCents(value) {
    if (value === null || value === undefined || String(value).trim() === '') {
      return null;
    }
    var cents = Number(value);
    return isFinite(cents) && cents >= 0 ? (cents / 100).toFixed(2) : null;
  }
  function validCurrency(value) {
    return typeof value === 'string' && /^[A-Z]{3}$/.test(value) ? value : null;
  }
  function activeCurrency() {
    try {
      return validCurrency(window.Shopify && window.Shopify.currency && window.Shopify.currency.active);
    } catch (e) {
      return null;
    }
  }
  function copyMeta(target, raw) {
    var productTitle = textOrNull(raw.productTitle) || textOrNull(raw.product_title);
    var variant = variantTitle(raw.variantTitle || raw.variant_title);
    var price = validPrice(raw.price);
    var currency = validCurrency(raw.currency);
    if (productTitle) {
      target.productTitle = productTitle;
    }
    if (variant) {
      target.variantTitle = variant;
    }
    if (price) {
      target.price = price;
    }
    if (currency) {
      target.currency = currency;
    }
  }

  function publish(name, entry, source) {
    try {
      var sa = window.Shopify && window.Shopify.analytics;
      if (sa && typeof sa.publish === 'function') {
        sa.publish(name, {
          product_id: entry.id || null,
          handle: entry.handle,
          variant_id: entry.variantId || null,
          source: source || entry.source || null
        });
      }
    } catch (e) {
      /* analytics must never break the wishlist */
    }
  }

  /* ---- strings (rendered by snippets/wishlist-drawer.liquid) ---- */
  var T = {
    add: 'Add to wishlist',
    remove: 'Remove from wishlist'
  };
  function readStrings() {
    var host = document.getElementById('Wishlist-Drawer');
    if (!host) {
      return;
    }
    if (host.getAttribute('data-t-add')) {
      T.add = host.getAttribute('data-t-add');
    }
    if (host.getAttribute('data-t-remove')) {
      T.remove = host.getAttribute('data-t-remove');
    }
  }

  /* ---- hearts + header count ---- */
  function syncButtons(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var buttons = scope.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      var on = indexOf(b.getAttribute('data-handle')) > -1;
      if (b.getAttribute('aria-pressed') !== String(on)) {
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      var label = on ? T.remove : T.add;
      if (b.getAttribute('aria-label') !== label) {
        b.setAttribute('aria-label', label);
      }
      b.classList.toggle('is-on', on);
    }
  }
  function syncCount() {
    var n = items.length;
    var counts = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < counts.length; i++) {
      counts[i].textContent = n > 99 ? '99+' : String(n);
      counts[i].classList.toggle('is-empty', n === 0);
    }
    var toggles = document.querySelectorAll('[data-wishlist-open]');
    for (var j = 0; j < toggles.length; j++) {
      var tpl = toggles[j].getAttribute('data-label-template');
      if (tpl) {
        toggles[j].setAttribute('aria-label', tpl.replace('[count]', n));
      }
    }
  }
  function changed(type, entry, source) {
    syncButtons(document);
    syncCount();
    var detail = { type: type, item: entry || null, source: source || null, items: items.slice() };
    listeners.forEach(function (fn) {
      try {
        fn(detail);
      } catch (e) {
        /* ignore listener errors */
      }
    });
    try {
      document.dispatchEvent(new CustomEvent('wishlist:change', { detail: detail }));
    } catch (e) {
      /* old browsers */
    }
  }

  /* ---- public store API ---- */
  function has(handle) {
    return indexOf(handle) > -1;
  }
  function add(data) {
    if (!data || !data.handle || has(data.handle)) {
      return false;
    }
    var entry = {
      handle: String(data.handle),
      id: toId(data.id),
      variantId: toId(data.variantId),
      addedAt: Date.now(),
      source: data.source || null,
      productTitle: textOrNull(data.productTitle),
      variantTitle: variantTitle(data.variantTitle),
      price: priceFromCents(data.priceCents) || validPrice(data.price),
      currency: validCurrency(data.currency) || activeCurrency()
    };
    items.unshift(entry);
    if (items.length > CAP) {
      items.length = CAP;
    }
    save();
    publish('wishlist_add', entry, entry.source);
    changed('add', entry, entry.source);
    return true;
  }
  function remove(handle, source, quiet) {
    var i = indexOf(handle);
    if (i < 0) {
      return false;
    }
    var entry = items.splice(i, 1)[0];
    save();
    if (!quiet) {
      publish('wishlist_remove', entry, source); /* quiet: pruning a deleted product */
    }
    changed('remove', entry, source);
    return true;
  }
  function toggle(data) {
    if (has(data.handle)) {
      remove(data.handle, data.source);
      return false;
    }
    add(data);
    return true;
  }

  /* Replace the whole list (phase 2 account sync). Saves and notifies with
     changed('replace', null, 'sync'): hearts, the count and the open panel
     refresh, but nothing is published to analytics and add/remove listeners
     stay quiet. Unknown/duplicate handles and non-numeric timestamps are
     dropped; the list is capped at CAP. */
  function replace(list) {
    var next = [];
    var seen = {};
    if (Array.isArray(list)) {
      for (var i = 0; i < list.length && next.length < CAP; i++) {
        var raw = list[i];
        if (!raw || typeof raw.handle !== 'string' || raw.handle === '' || seen[raw.handle]) {
          continue;
        }
        var addedAt = parseInt(raw.addedAt, 10);
        seen[raw.handle] = true;
        var entry = {
          handle: raw.handle,
          id: toId(raw.id),
          variantId: toId(raw.variantId),
          addedAt: isNaN(addedAt) || addedAt <= 0 ? Date.now() : addedAt,
          source: raw.source || null
        };
        copyMeta(entry, raw);
        next.push(entry);
      }
    }
    items = next;
    save();
    changed('replace', null, 'sync');
    return items.length;
  }

  /* ---- heart clicks (delegated). Hearts are buttons, so the homepage keycap
     card does not open the modal and no card link navigates. ---- */
  function sourceOf(btn) {
    var s = btn.getAttribute('data-wishlist-source');
    if (s) {
      return s;
    }
    if (btn.closest('#KeycapModal')) {
      return 'modal';
    }
    if (btn.closest('#Wishlist-Drawer')) {
      return 'panel';
    }
    return 'card';
  }
  function variantOf(btn) {
    if (!btn.hasAttribute('data-wishlist-variant-from-form')) {
      return null;
    }
    var form = btn.closest('form') || document.querySelector('form[data-type="add-to-cart-form"]');
    var input = form ? form.querySelector('[name="id"]') : null;
    return input ? input.value : null;
  }
  function variantMap(btn) {
    var raw = btn.getAttribute('data-wishlist-variants');
    var map = null;
    if (raw) {
      try {
        /* snippets/wishlist-button.liquid emits the map contents without the
           outer braces, keeping the JSON small in the PDP markup. */
        map = JSON.parse(raw.charAt(0) === '{' ? raw : '{' + raw + '}');
      } catch (e) {
        map = null;
      }
    }
    return map && typeof map === 'object' ? map : {};
  }
  function heartData(btn) {
    var fromForm = btn.hasAttribute('data-wishlist-variant-from-form');
    var formId = variantOf(btn);
    var attrId = btn.getAttribute('data-variant-id');
    var variantId = fromForm && formId ? formId : attrId;
    var map = variantMap(btn);
    var variant = variantId ? map[String(variantId)] : null;
    var sameAsInitial = !attrId || String(variantId) === String(attrId);
    var title = variant && typeof variant.t === 'string' ? variant.t : (sameAsInitial ? btn.getAttribute('data-variant-title') : null);
    var cents = variant && variant.p !== null && variant.p !== undefined ? variant.p : (sameAsInitial ? btn.getAttribute('data-price-cents') : null);
    return {
      variantId: variantId || null,
      productTitle: textOrNull(btn.getAttribute('data-product-title')),
      variantTitle: variantTitle(title),
      priceCents: cents,
      currency: activeCurrency()
    };
  }
  document.addEventListener('click', function (e) {
    var target = e.target instanceof Element ? e.target : null;
    var btn = target ? target.closest('[data-wishlist-toggle]') : null;
    if (!btn) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    var data = heartData(btn);
    data.handle = btn.getAttribute('data-handle');
    data.id = btn.getAttribute('data-product-id');
    data.source = sourceOf(btn);
    var on = toggle(data);
    if (on) {
      btn.classList.remove('is-pop');
      void btn.offsetWidth; /* restart the pop animation */
      btn.classList.add('is-pop');
      window.setTimeout(function () {
        btn.classList.remove('is-pop');
      }, 700);
    }
  });

  /* ---- cross-tab sync ---- */
  window.addEventListener('storage', function (e) {
    if (e.key !== null && e.key !== KEY) {
      return;
    }
    items = load();
    changed('sync', null, 'storage');
  });

  /* ---- hearts rendered later (modal cards, AJAX grids, recommendations) ---- */
  var pending = false;
  function schedule() {
    if (pending) {
      return;
    }
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      syncButtons(document);
    });
  }
  function init() {
    readStrings();
    syncButtons(document);
    syncCount();
    if (window.MutationObserver) {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          if (records[i].addedNodes && records[i].addedNodes.length) {
            schedule();
            return;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  window.YPWishlist = {
    key: KEY,
    cap: CAP,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    replace: replace,
    list: function () {
      return items.slice();
    },
    count: function () {
      return items.length;
    },
    publish: publish,
    refresh: function (root) {
      syncButtons(root || document);
      syncCount();
    },
    onChange: function (fn) {
      if (typeof fn === 'function') {
        listeners.push(fn);
      }
    },
    strings: T
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
